import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import SizeAliasesDashboard from '../SizeAliases/SizeAliasesDashboard';
import SizeSchemasDashboard from '../SizeSchemas/SizeSchemasDashboard';
import SizeCurvesDashboard from '../SizeCurves/SizeCurvesDashboard';
import UnknownSizesDashboard from '../UnknownSizes/UnknownSizesDashboard';

const TABS = [
  { value: 'aliases', label: 'Aliases', component: <SizeAliasesDashboard /> },
  { value: 'schemas', label: 'Schemas', component: <SizeSchemasDashboard /> },
  { value: 'curves', label: 'Curves', component: <SizeCurvesDashboard /> },
  { value: 'unknown', label: 'Unknown Sizes', component: <UnknownSizesDashboard /> },
];

export default function SizeNormalizationDashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const active = params.get('tab') || 'aliases';

  const handleChange = (_e, value) => {
    navigate(`/size-normalization?tab=${value}`, { replace: true });
  };

  const current = TABS.find(t => t.value === active) || TABS[0];

  return (
    <Box>
      <Tabs value={current.value} onChange={handleChange} sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        {TABS.map(t => <Tab key={t.value} value={t.value} label={t.label} />)}
      </Tabs>
      {current.component}
    </Box>
  );
}
